import { api_fetch, api_fetch_throws, HttpError, HttpResponse } from "./client"
import { Recipient, UserFile } from "./deduction"
import { Result } from "@/utils"

/** A candidate attachment within a matched email thread. */
export interface BolEmailAttachment {
  attachment_id: string
  name: string
  s3_uri: string
  content_type: string
  created_at: string
  /** Which search terms matched (empty for already-synced threads). */
  matched_terms: string[]
  /** Already linked to the deduction (pre-checked + disabled in the UI). */
  already_linked: boolean
}

/** An email thread grouping one or more candidate attachments. */
export interface BolEmailThreadMatch {
  message_id: string
  thread_id: string
  subject: string
  from: Recipient
  date: string | null
  snippet: string
  attachments: BolEmailAttachment[]
}

export interface BolEmailSearchResponse {
  /** The terms actually searched (invoice/PO defaults, or the custom query). */
  search_terms: string[]
  matches: BolEmailThreadMatch[]
}

export interface LinkBolEmailResult {
  linked_via_row: number
  linked_via_user_files: number
  skipped: number
  user_files: UserFile[]
}

/** Search synced emails for BOLs/docs matching the deduction's invoice/PO defaults, or `q` if given. */
export async function search_bol_email(deduction_id: string, q?: string): Promise<BolEmailSearchResponse> {
  const opts = q && q.trim() ? { params: { q: q.trim() } } : undefined
  return api_fetch_throws<BolEmailSearchResponse>(`/deduction/${deduction_id}/bol-email/search`, opts)
}

/** Link the user-selected email attachments to the deduction. */
export async function link_bol_email(
  deduction_id: string,
  attachment_ids: string[]
): Promise<Result<HttpResponse<LinkBolEmailResult>, HttpError>> {
  return api_fetch<LinkBolEmailResult>(`/deduction/${deduction_id}/bol-email/link`, {
    body: { attachment_ids },
  })
}
